import { Spin, Table, Button, Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  BulkUploadFilter,
  getBulkUploadList,
  BulkUploadList,
  BulkUploadPagedList,
  getBulkUploadFile,
} from 'api/dashboard';
import { PascalCaseBulkUploadRequest } from 'api/agent';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { useEffect, useState } from 'react';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import moment from 'moment';

let bulkUploadPagedList: BulkUploadPagedList;
type Props = {
  bulkUploadFilter: BulkUploadFilter;
  onSubmit: (values: BulkUploadFilter) => Promise<void>;
  reloadByTabChange: boolean;
};
const BulkUploadListPage = ({ bulkUploadFilter: filter, reloadByTabChange }: Props) => {
  const [pagedList, setPagedList] = useState(bulkUploadPagedList);
  const [isLoading, setIsLoading] = useState(false);

  const fetchBulkUploadDashboard = (filter: BulkUploadFilter) => {
    getBulkUploadList(filter)
      .then((res) => {
        if (res.data.data != null) {
          debugger;
          res.data.data.forEach((bulkUpload, bulkUploadIndex) => {
            bulkUpload.key = bulkUploadIndex + 1;
          });
        }
        debugger;
        setPagedList(res.data);
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  useEffect(() => {
    debugger;
    setIsLoading(false);
    setPagedList(bulkUploadPagedList);
    let fil = { ...filter };
    fil.pageNo = 1;
    fetchBulkUploadDashboard(fil);
  }, [filter, reloadByTabChange]);

  function getFullDate(date: string) {
    if (date != null) {
      let dateMoment = moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss');
      return dateMoment;
    }
  }

  const bulkUploadColumns: ColumnsType<BulkUploadList> = [
    {
      key: 'bulkUploadFileId',
      title: 'File Id',
      dataIndex: 'bulkUploadFileId',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      fixed: 'left',
    },
    {
      key: 'fileName',
      title: 'File Name',
      dataIndex: 'fileName',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          <Typography.Text ellipsis={true}>{record}</Typography.Text>
        </Tooltip>
      ),
      fixed: 'left',
    },
    {
      key: 'totalRecord',
      title: 'Total Records',
      dataIndex: 'totalRecord',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'totalSuccessRecord',
      title: 'Success Record',
      dataIndex: 'totalSuccessRecord',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'totalFailedRecord',
      title: 'Failed Record',
      dataIndex: 'totalFailedRecord',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'uploadStatus',
      title: 'Status',
      dataIndex: 'uploadStatus',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },

    {
      key: 'createdDate',
      title: 'Created Date',
      dataIndex: 'createdDate',
      ellipsis: true,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'createdBy',
      title: 'Created By',
      dataIndex: 'createdBy',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          <Typography.Text ellipsis={true}>{record}</Typography.Text>
        </Tooltip>
      ),
    },
    {
      key: 'downloadFile',
      title: 'Export',
      dataIndex: 'downloadFile',
      ellipsis: true,
      //fixed: 'right',
      render: (_text, record) => (
        <Button
          className="ant-btn ant-btn-primary"
          size="small"
          onClick={() => downloadFile(record)}
        >
          EXPORT
        </Button>
      ),
    },
  ];

  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any) => {
    debugger;
    setIsLoading(false);
    filter.isExtract = false;
    filter.pageNo = _pagination.current;
    filter.pageSize = _pagination.pageSize;

    fetchBulkUploadDashboard(filter);
  };

  const downloadFile = (record: BulkUploadList) => {
    setIsLoading(false);
    debugger;
    const fetchFileFilter = {
      bulkUploadFileId: record.bulkUploadFileId,
    };

    const pascalCaseBulkUploadRequestList: PascalCaseBulkUploadRequest[] = [];
    getBulkUploadFile(fetchFileFilter)
      .then((res) => {
        debugger;
        if (res.data != null) {
          debugger;
          res.data.forEach((bulkUpload) => {
            const pascalCaseBulkUploadRequest: PascalCaseBulkUploadRequest = {
              LoanNumber: bulkUpload.loanNumber,
              PaymentPurpose: bulkUpload.paymentPurpose,
              Amount: bulkUpload.amount,
              AccountName: bulkUpload.accountName,
              EmailId: bulkUpload.emailId,
              MobileNo: bulkUpload.mobileNo,
              ApplicantType: bulkUpload.applicantType,
              Status: bulkUpload.requestStatus,
              ErrorMessage: bulkUpload.requestErrorMessage?.replaceAll(',', '|'),
              CreatedDate: bulkUpload.createdDate,
            };
            debugger;
            pascalCaseBulkUploadRequestList.push(pascalCaseBulkUploadRequest);
          });
          debugger;
          const csvConfig = mkConfig({
            useKeysAsHeaders: true,
            filename: record.fileName.replace('.csv', ''),
          });
          const csv = generateCsv(csvConfig)(pascalCaseBulkUploadRequestList);
          download(csvConfig)(csv);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const dataTable = calculateColumnsWidth(bulkUploadColumns, pagedList.data, 300);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';
  return (
    <>
      <div>
        <div className="row" style={{ margin: '10px' }}></div>
        <Spin spinning={!isLoading}>
          <div>
            <Table
              dataSource={dataTable.source}
              columns={dataTable.columns}
              rowKey={rowKey}
              scroll={{ x: dataTable.tableWidth, y: tableHeight }}
              onChange={handleChange}
              pagination={{
                pageSize: 10,
                total: pagedList.noOfRecords,
                current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
              }}
            />
          </div>
        </Spin>
      </div>
    </>
  );
};

export default BulkUploadListPage;
